import { sendBeacon } from '@/utils/core.client'
import { GOOGLE_ADS_CLICK_ID_KEYS, isGoogleAdsClickId } from '@/utils/google-ads-click-ids'

const GOOGLE_ADS_COOKIE_MAX_AGE = 90 * 24 * 60 * 60
const GOOGLE_ADS_COOKIE_DOMAIN = '.planetscale.com'

export function captureGoogleAdsClickIds() {
  const params = new URLSearchParams(location.search)

  for (const key of GOOGLE_ADS_CLICK_ID_KEYS) {
    const value = params.get(key)

    if (!isGoogleAdsClickId(value) || cookieValue(`ps_${key}`)) {
      continue
    }

    document.cookie = [
      `ps_${key}=${encodeURIComponent(value)}`,
      `Domain=${GOOGLE_ADS_COOKIE_DOMAIN}`,
      'Path=/',
      `Max-Age=${GOOGLE_ADS_COOKIE_MAX_AGE}`,
      'SameSite=Lax',
      'Secure'
    ].join('; ')
  }
}

export function page() {
  const formData = new FormData()
  formData.append('context', JSON.stringify(context()))
  formData.append('name', location.pathname)
  formData.append('source', 'www')
  sendBeacon('/analytics/page', formData)
}

export function track(event: string, properties = {}) {
  const formData = new FormData()
  formData.append('context', JSON.stringify(context()))
  formData.append('event', event)
  formData.append('properties', JSON.stringify(properties))
  formData.append('source', 'www')
  sendBeacon('/analytics/track', formData)
}

export function context(ctx = {}) {
  return {
    ...ctx,
    page: {
      path: location.pathname,
      referrer: document.referrer,
      search: location.search,
      title: document.title,
      url: canonicalUrl()
    }
  }
}

function canonicalUrl(): string {
  const canon = canonical()

  if (canon) {
    return canon.includes('?') ? canon : `${canon}${location.search}`
  }

  const url = window.location.href
  const i = url.indexOf('#')

  return i === -1 ? url : url.slice(0, i)
}

function canonical(): string | null {
  return document.querySelector('link[rel="canonical"]')?.getAttribute('href') ?? null
}

function cookieValue(name: string): string | undefined {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${encodeURIComponent(name)}=`) || row.startsWith(`${name}=`))

  return cookie ? cookie.split('=').slice(1).join('=') : undefined
}
